module.exports = __webpack_public_path__ + "static/NATO-Technical-Group-e2cf8a977eb14c6a3fe105f5e267bc0d.jpeg";